module.exports = __webpack_public_path__ + "static/media/asbesti-min.d361811e.jpg";